import { render, staticRenderFns } from "./TwHeader.vue?vue&type=template&id=053a15fc&scoped=true&"
import script from "./TwHeader.vue?vue&type=script&lang=js&"
export * from "./TwHeader.vue?vue&type=script&lang=js&"
import style0 from "./TwHeader.vue?vue&type=style&index=0&id=053a15fc&lang=scss&scoped=true&"
import style1 from "./TwHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053a15fc",
  null
  
)

export default component.exports